<template>
    <div class="container-mCircleProgress" :id="containerId">
        <canvas :id="canvasId" :style="{'width':width + 'px','height':height + 'px'}"></canvas>          
    </div>
</template>

<script>

export default {
    name:'mCircleProgress',
    props: {      
        maxCount: {
            type: Number,
            default: 100
        },                    
        progress: {
            type: Number,
            default: 0
        },    
        circleColor: {
            type: String,
            default: '#62D9BE'
        },           
        backgroundCircleColor: {
            type: String,
            default: ''
        },                          
    }, 
    data() {
        return {
            circleLoading1: null,  
            canvasId: "canvas-mCircleProgress",
            containerId: "container-mCircleProgress",

            process: 0,  
            width: 0,
            height: 0,     
        };
     },
     created(){
        this.canvasId = "canvas-mCircleProgress" + + Math.floor(Math.random() * 1000000);
        this.containerId = "container-mCircleProgress" + + Math.floor(Math.random() * 1000000);
        this.$nextTick (() => {
            this.load();
        })
     },     
    watch: {
        progress(val) {
            // console.log(val);
            this.load();
        },
    },         
     methods: {      
        load(){
            let containerProgress = document.getElementById(this.containerId);
            let container = containerProgress.getBoundingClientRect();

            this.width = container.width;
            this.height = container.height;

            let canvas = document.getElementById(this.canvasId);
            // console.log(this.canvasId);
            let context = canvas.getContext("2d");
         
            let dpr = window.devicePixelRatio; // 假设dpr为2
            // console.log('dpr',dpr);
            // dpr = 1.5;
            // let dpr = 3; // 假设dpr为2
            // console.log(dpr);
            // 获取css的宽高
            // let { width: cssWidth, height: cssHeight } = canvas.getBoundingClientRect();
            // console.log(cssWidth,cssHeight);
            // 根据dpr，扩大canvas画布的像素，使1个canvas像素和1个物理像素相等
            canvas.width = dpr * this.width;
            canvas.height = dpr * this.height;      
            
            let radiusLine = 10*dpr;
            this.radiusLine = radiusLine;
  
            this.process = 0;

            this.circleLoading1 = setInterval(() => {
                // console.log('that.processPefect',this.processPefect,this.pefectValue);
                if (this.process >= this.progress) {
                    this.process = this.progress;
                    this.drawCircle(context, canvas, dpr);
                    clearInterval(this.circleLoading1);
                } else {
                    this.drawCircle(context, canvas, dpr);
                    // this.drawCircle(context, canvas, dpr);
                }               

                if (this.process < this.progress) {
                    if (this.progress - this.process >= 10) {
                        this.process += 9;                                                
                    } else {
                        this.process += 1.0;                            
                    }                       
                }              
            }, 10);            

        },       
        drawCircle(context, canvas, dpr) {

                context.clearRect(0,0,canvas.width,canvas.height);

                context.save();                

                let center_x = canvas.width / 2;
                let center_y = canvas.height / 2;              

                context.translate(center_x,center_y);  

                context.lineWidth = this.radiusLine;

                let radius = Math.min(canvas.width,canvas.height)/2 - this.radiusLine/2;

                if (this.backgroundCircleColor) {
                    context.strokeStyle = this.backgroundCircleColor;
                    context.beginPath();
                    context.arc(0, 0, radius, -Math.PI/2, -Math.PI/2 + 2*Math.PI);
                    // context.closePath()
                    context.stroke();                        
                }                  
                
                context.strokeStyle = this.circleColor;
                context.beginPath();
                context.arc(0, 0, radius, -Math.PI/2, -Math.PI/2 + this.process/this.maxCount*2*Math.PI);
                // context.closePath()
                context.stroke();    

                context.restore();
            // } 
        },             
    }
}    
</script>

<style scoped>
.container-mCircleProgress {
    box-sizing: border-box;
    /* background-color: burlywood; */
    position: relative;
}
</style>